@if (control) {
    <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
        @if (label) {
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                <div class="t5 c-primary-gray-600">{{ label | translate }} {{ control.hasValidator(Validators.required) ? '*' : '' }}
                </div>
                @if (tooltip) {
                    <ui-kit-svg class="i-16 c-primary-gray-600 pointer" name="ic_help"
                                matTooltipClass="pre-line" [matTooltip]="tooltip"/>
                }
            </div>
        }
        <mat-form-field class="w-100" fxFlex
                        [class.mt-4]="label"
                        [class.value-not-empty]="control.value && (!isMultiple || control.value?.length > 0) && !disabled">
            @if (Spinner.isShown(dictionaryName) && !isMultiple) {
                <input type="text"
                       [placeholder]="placeholder | translate"
                       matInput
                       [value]="selectAllLabel | translate"
                       [formControl]="control">
            }
            @if (!Spinner.isShown(dictionaryName) && dictionary?.length < 10 && !isMultiple) {
                <mat-select
                    [formControl]="control"
                    hideSingleSelectionIndicator
                    class="h-100"
                    fxLayoutAlign="start center"
                    panelClass="overflow-y-scroll"
                    (openedChange)="onSelectOpened($event)"
                    [placeholder]="placeholder | translate">
                    @if (shouldAddSelectAll) {
                        <mat-option
                            #selectAll
                            [value]="SELECT_ALL_VALUE"
                            [class.selected]="isSelectAllSelected"
                            (click)="toggleAll()">
                            {{ selectAllLabel | translate }}
                        </mat-option>
                    }
                    @if (shouldAddClearOption && !isMultiple) {
                        <mat-option [value]="null">{{ clearOptionLabel | translate }}</mat-option>
                    }
                    @for (item of filteredDictionary; track item) {
                        <mat-option [value]="item.code">
                            {{ (translationPrefix + displayName(item)) | translate }}
                        </mat-option>
                    }
                    @if (shouldHandleUnlistedValue && !isSelectPanelOpen) {
                        <mat-option [value]="control.value">{{ unlistedValueLabel }}</mat-option>
                    }
                </mat-select>
            }
            @if (!Spinner.isShown(dictionaryName) && dictionary?.length >= 10 || isMultiple) {
                <input type="text"
                       [placeholder]="placeholder | translate"
                       matInput
                       (click)="clearSearchField()"
                       uiKitClickOutside
                       (clickOutside)="updateDisplayedValue()"
                       (blur)="control.markAsTouched()"
                       [formControl]="searchControl"
                       [errorStateMatcher]="controlErrorStateMatcher"
                       [matAutocomplete]="autocomplete">
                <mat-autocomplete #autocomplete="matAutocomplete"
                                  hideSingleSelectionIndicator
                                  (optionSelected)="handleSelection($event)">
                    @if (shouldAddSelectAll) {
                        <mat-option #selectAll [value]="SELECT_ALL_VALUE"
                                    [class.selected]="selectedItems.length === dictionary.length || isSelectAllSelected">
                            @if (isMultiple) {
                                <mat-checkbox
                                    [checked]="selectedItems.length === dictionary.length || isSelectAllSelected"
                                    color="primary">
                                    {{ selectAllLabel | translate }}
                                </mat-checkbox>
                            }
                            @if (!isMultiple) {
                                {{ selectAllLabel | translate }}
                            }
                        </mat-option>
                    }
                    @if (shouldAddClearOption && !isMultiple) {
                        <mat-option [value]="CLEAR_VALUE">{{ clearOptionLabel | translate }}</mat-option>
                    }
                    @for (item of filteredDictionary; track item) {
                        <mat-option [value]="item.code"
                                    [class.selected]="isChecked(item)">
                            @if (isMultiple) {
                                <mat-checkbox
                                    [checked]="isChecked(item)"
                                    color="primary">
                                    {{ (translationPrefix + displayName(item)) | translate }}
                                </mat-checkbox>
                            }
                            @if (!isMultiple) {
                                {{ (translationPrefix + displayName(item)) | translate }}
                            }
                        </mat-option>
                    }
                </mat-autocomplete>
            }
            @if (hintTranslationKey) {
                <mat-hint class="t5 c-primary-gray-600" [textContent]="hintTranslationKey | translate"/>
            }
            <div matSuffix class="mr-16">
                <ui-kit-spinner [spinnerIds]="dictionaryName"
                                [diameter]="16"
                                [strokeWidth]="3"/>
            </div>
            @if (!Spinner.isShown(dictionaryName)) {
                <ui-kit-svg
                    matSuffix
                    class="i-16 mr-16 pointer c-primary-gray-600"
                    name="ic_arrow_down"/>
            }
            @if (control.hasError('required')) {
                <mat-error
                    class="c-secondary-red-900">
                    {{ 'i18n_af_fieldValidationRequired' | translate }}
                </mat-error>
            }
        </mat-form-field>
    </div>
}
